const pink = {
  100: "#FEF6FB",
  200: "#FEE6F6",
  300: "#FEC3EA",
  400: "#FB9DDA",
  500: "#F566C3",
  600: "#E723A6",
  700: "#CA168F",
  800: "#AE137B",
  900: "#6E0C57",
  contrastDefaultColor: "#ffffff"
}

export default pink
